/*
 * START_MODULE_CONTRACT
 *   PURPOSE: Root layout wrapper rendering TopNav header above flexing main content area
 *   PROPS:   children (ReactNode) + extends HTML div attributes
 *   STATE:   none
 *   DEPENDS: M-TNV (TopNav), M-CN (cn)
 *   EMITS:   none
 *   ACCESSIBILITY: semantic structure (header + main)
 *   LINKS:   M-SHL
 * END_MODULE_CONTRACT
 *
 * CHANGE_SUMMARY
 *   [2026-06-12] Added GRACE MODULE_CONTRACT and semantic blocks — no behavior change
 */

import { forwardRef } from "react"
import { cn } from "@/lib/cn"
import { TopNav } from "@/components/layout/top-nav"

// --- TypeDefinitions ---
interface ShellProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

// --- ShellComponent ---
const Shell = forwardRef<HTMLDivElement, ShellProps>(({ className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={cn("flex min-h-screen flex-col bg-canvas-dark", className)} {...props}>
      <TopNav />
      <main className="flex-1">
        {children}
      </main>
    </div>
  )
})
Shell.displayName = "Shell"

export { Shell }
export type { ShellProps }
